// extracted by mini-css-extract-plugin
module.exports = {"resume":"Resume_resume__2oDEB","timeRange":"Resume_timeRange__1bsLW","moreLink":"Resume_moreLink__7p4za","subColumns":"Resume_subColumns__2Z9lk"};